export default {"theme":{"dark":true,"options":{"customProperties":true},"themes":{"dark":{"primary":"#90caf9","accent":"#2962ff","secondary":"#4dd0e1","background":"#131E2A"}}}}
